import { connect } from 'react-redux';
import { CommonService } from './CommonService';
import {
  ICommonServiceOwnProps,
  ICommonServiceStateProps,
  ICommonServiceDispatchProps,
  ICommonServiceProps,
} from './types';
import { IAppState } from '../../../../redux';
import { selectPublishTermsService } from '../../../../redux/reducers';
import { trackServiceClick, trackUnavailableServiceClick } from './CommonService.tracking';
import {
  selectActiveOptionByServiceId,
  selectActiveServiceId,
  selectServiceById,
} from '../../../../selectors/publishTerms';
import { SERVICE_DESCRIPTIONS } from './constants';
import { selectIsNewOffer } from '../../../../selectors/offer';

export const mapStateToProps = (state: IAppState, props: ICommonServiceOwnProps): ICommonServiceStateProps => {
  const { serviceId } = props;

  const isNewOffer = selectIsNewOffer(state);
  const currentService = selectServiceById(serviceId, state);
  const selectedOption = selectActiveOptionByServiceId(serviceId, state);
  const selectedServiceId = selectActiveServiceId(state);

  const isActive = serviceId === selectedServiceId;
  const discount = selectedOption?.discount || null;

  return {
    isNewOffer,
    service: currentService,
    isActive,
    discount,
  };
};

export const mapDispatchToProps = {
  selectPublishTermsService,
};

export const mergeProps = (
  stateProps: ICommonServiceStateProps,
  dispatchProps: ICommonServiceDispatchProps,
): ICommonServiceProps => {
  const { isNewOffer, service, isActive, discount } = stateProps;
  const { selectPublishTermsService } = dispatchProps;
  const { id, name, isAvailable } = service;

  const onCardClick = () => {
    if (isActive) {
      return;
    }

    if (isAvailable) {
      selectPublishTermsService(id);
      trackServiceClick(id, isNewOffer);
    } else {
      trackUnavailableServiceClick(id, isNewOffer);
    }
  };

  return {
    id,
    name,
    description: SERVICE_DESCRIPTIONS[id],
    isAvailable,
    isActive,
    discount,
    onCardClick,
  };
};

export const CommonServiceContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(CommonService);
